export function uint8ArrayToBase64(uint8Array: any[]) {
  let binaryString = '';
  uint8Array.forEach((byte) => {
    binaryString += String.fromCharCode(byte);
  });
  return btoa(binaryString);
}

/**
 * Get Key Message based on DRM provider.
 * @param drm - DRM configuration object
 * @param keyMessage - The original key message
 * @returns Processed key message suitable for the DRM provider
 */
export function getKeyMessage({
  drm,
  keyMessage,
}: {
  drm: any;
  keyMessage: any;
}) {
  // DOTO: Refactor when more providers are added

  const isRawMessage = drm?.fairplay?.provider === 'jwplayer';

  if (isRawMessage) return keyMessage;

  // provider === 'theplatform' (Comcast)
  return JSON.stringify({
    server_playback_context: uint8ArrayToBase64(keyMessage),
  });
}
